module.exports = __webpack_public_path__ + "static/media/POST_WILL_END.9a81a97c.png";